var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSymbolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8783 7.4528H6.71159V11.6195C6.71159 12.0778 6.33659 12.4528 5.87826 12.4528C5.41992 12.4528 5.04492 12.0778 5.04492 11.6195V7.4528H0.878255C0.419922 7.4528 0.0449219 7.0778 0.0449219 6.61947C0.0449219 6.16113 0.419922 5.78613 0.878255 5.78613H5.04492V1.61947C5.04492 1.16113 5.41992 0.786133 5.87826 0.786133C6.33659 0.786133 6.71159 1.16113 6.71159 1.61947V5.78613H10.8783C11.3366 5.78613 11.7116 6.16113 11.7116 6.61947C11.7116 7.0778 11.3366 7.4528 10.8783 7.4528Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSymbolIcon);
export default __webpack_public_path__ + "static/media/add-symbol-icon.6f54be92ccb90bb9a678dbd61017a4e5.svg";
export { ForwardRef as ReactComponent };